/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MetaTags from 'react-meta-tags';
import dynamicImportModules from '@/utils/helper/dynamicImportModules';
import {
  AddressProps,
  OrderDetailProps,
  OrderViewProps,
  PaymentResultProps,
  HowToPayProps,
  Subscription,
} from '@/types';
import { MainLayout } from '@/components/layout';
import LanguagePreferenceBar from '../LanguagePreferenceBar';

const PaymentOrderOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/PaymentOrderOrderDetail')
);
const PendingAddressOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/PendingAddressOrderDetail')
);
const WaitingForPaymentOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/WaitingForPaymentOrderDetail')
);
const PaymentExpiredOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/PaymentExpiredOrderDetail')
);
const CanceledOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/CanceledOrderDetail')
);
const DefaultViewOrderDetail = dynamicImportModules<OrderDetailProps>(
  import('@/modules/Order/StatusView/DefaultViewOrderDetail')
);

const Address = dynamicImportModules<AddressProps>(
  import('@/modules/AddressMap')
);
const PaymentResult = dynamicImportModules<PaymentResultProps>(
  import('@/modules/PaymentResult')
);
const HowToPay = dynamicImportModules<HowToPayProps>(
  import('@/modules/HowToPay')
);

// eslint-disable-next-line prettier/prettier
const OrderView = ({
  renderPageConstant,
  subscription,
  ...rest
}: OrderViewProps) => {
  const componentProps = { subscription, ...rest };
  const components: Record<Subscription['status'], JSX.Element> = {
    payment_order: <PaymentOrderOrderDetail {...componentProps} />,
    pending_address: <PendingAddressOrderDetail {...componentProps} />,
    waiting_for_payment: <WaitingForPaymentOrderDetail {...componentProps} />,
    payment_expired: <PaymentExpiredOrderDetail {...componentProps} />,
    payment_failed: <PaymentExpiredOrderDetail {...componentProps} />,
    order_cancelled: <CanceledOrderDetail {...componentProps} />,
  };

  if (
    Object.keys(subscription).length &&
    components[subscription.status] === undefined &&
    renderPageConstant.page !== 'PAYMENT_STATUS_PAGE'
  ) {
    return (
      <MainLayout>
        <MetaTags>
          <title>{rest.renderTitle()}</title>
        </MetaTags>
        <LanguagePreferenceBar />
        <DefaultViewOrderDetail {...componentProps} />
      </MainLayout>
    );
  }

  switch (renderPageConstant.page) {
    case 'ADDRESS_MAP': {
      return (
        <Address
          {...componentProps}
          isEditable={renderPageConstant.isEditable}
        />
      );
    }
    case 'DETAIL_SUBSCRIPTION': {
      if (!Object.keys(subscription).length) return null;

      return (
        <MainLayout>
          <MetaTags>
            <title>{rest.renderTitle()}</title>
          </MetaTags>
          <LanguagePreferenceBar />
          {components[subscription.status]}
        </MainLayout>
      );
    }
    case 'HOW_TO_PAY_PAGE': {
      return (
        <HowToPay
          subscription={subscription}
          setRenderPageOrderConstant={rest.setRenderPageOrderConstant}
        />
      );
    }
    case 'PAYMENT_STATUS_PAGE': {
      return (
        <PaymentResult
          subscription={subscription}
          isPaymentSucessfull={rest.isPaymentSucessfull}
        />
      );
    }
    default:
      return null;
  }
};

export default OrderView;
